import { createReducer, on } from '@ngrx/store';
import * as LookupDefinitionsActions from '../actions/lookupdefinitions.action';

export interface LookupDefinitionsState {
    getSuccess?: any;
    getFailure?: any;
    saveSuccess?: any;
    saveFailure?: any;
    updateSuccess?: any;
    updateFailure?: any;
    deleteSuccess?: any;
    deleteFailure?: any;
    getByIdSuccess?: any;
    getByIdFailure?: any;
}

export const initialState: LookupDefinitionsState = {};

export const lookupDefinitionsReducer = createReducer(
    initialState,
    // Get
    on(LookupDefinitionsActions.getLookupDefinitionsSuccess, (state, { payload }) => ({
        ...state,
        getSuccess: payload,
        getFailure: null
    })),
    on(LookupDefinitionsActions.getLookupDefinitionsFailure, (state, { error }) => ({
        ...state,
        getFailure: error,
        getSuccess: null
    })),

    //GetBy Id
    on(LookupDefinitionsActions.getLookupDefinitionByIdSuccess, (state, { payload }) => ({
        ...state,
        getByIdSuccess: payload,
        getByIdFailure: null
    })),
    on(LookupDefinitionsActions.getLookupDefinitionByIdFailure, (state, { error }) => ({
        ...state,
        getByIdFailure: error,
        getByIdSuccess: null
    })),

    // Save
    on(LookupDefinitionsActions.saveLookupDefinitionsSuccess, (state, { payload }) => ({
        ...state,
        saveSuccess: payload,
        saveFailure: null
    })),
    on(LookupDefinitionsActions.saveLookupDefinitionsFailure, (state, { error }) => ({
        ...state,
        saveFailure: error,
        saveSuccess: null
    })),
    // Update
    on(LookupDefinitionsActions.updateLookupDefinitionsSuccess, (state, { payload }) => ({
        ...state,
        updateSuccess: payload,
        updateFailure: null
    })),
    on(LookupDefinitionsActions.updateLookupDefinitionsFailure, (state, { error }) => ({
        ...state,
        updateFailure: error,
        updateSuccess: null
    })),
    // Delete
    on(LookupDefinitionsActions.deleteLookupDefinitionsSuccess, (state, { payload }) => ({
        ...state,
        deleteSuccess: payload,
        deleteFailure: null
    })),
    on(LookupDefinitionsActions.deleteLookupDefinitionsFailure, (state, { error }) => ({
        ...state,
        deleteFailure: error,
        deleteSuccess: null
    }))
);